import {Controller} from "stimulus"
import $ from 'jquery';

export default class extends Controller {

    initialize() {
        if (!this.element.dataset.hasOwnProperty('connect') && this.element.dataset.connect !== 'true')
            $(this.element).on('change', (e) => {
                let target_input = $(`#${e.currentTarget.dataset.target}`)
                if (e.currentTarget.checked) {
                    e.currentTarget.dataset.check.split(',').map(id => {
                        $(`#${id}`).prop('checked', false).trigger('change');
                    })
                    target_input.val('0').prop('disabled', false);
                } else {
                    target_input.val('0').prop('disabled', true);
                }
            })
    }

    connect() {
        if (this.element.dataset.hasOwnProperty('connect') && this.element.dataset.connect === 'true') {
            $(this.element).on('change', (e) => {
                e.currentTarget.dataset.evaluate.split(',').map(id => {
                    if(e.currentTarget.checked){
                        $(`#${id.trim()}`).prop('checked', !e.currentTarget.checked);
                    }
                })
                $(`.${this.element.dataset.target}`).prop('checked', e.currentTarget.checked).trigger('change');
            })
        }
    }

}